import React from 'react';
import I18n from '@/modules/i18n';
import AIBadge from '@/components/shared/AIBadge';
import Icon from '@/components/ui/Icon';
import { GradientSpinner } from '@/components/ui/Spinner';
import Text from '@/components/ui/Text';
import { IAISuggestion } from '@/components/staffer/Grading/types';
import cn from '@/utils/cn';

const LABEL_KEYS = {
  ai_accepted_as_is: 'ai_accepted_score',
  ai_edited: 'ai_rejected_score',
  ai_rejected: 'ai_rejected_score',
  ai_suggested_pending: 'ai_suggested_score',
};

interface AISuggestionChipProps {
  score?: string;
  state: IAISuggestion['state'];
}

const AISuggestionChip = ({ score, state }: AISuggestionChipProps) => (
  <span
    key={state}
    className={cn(
      'tw-inline-flex tw-shrink-0 tw-items-center tw-gap-2 tw-h-8 tw-pl-2 tw-pr-2.5 tw-whitespace-nowrap',
      'tw-rounded-full tw-bg-tci-purple/10',
      { 'tw-animate-in tw-fade-in tw-duration-100': state === 'ai_accepted_as_is' },
    )}
  >
    {state === 'generating' ? (
      <>
        <span className="-tw-m-1 tw-flex"><GradientSpinner size={28} /></span>
        <Text className="tw-text-tci-black tw-ml-1.5" size="sm" tag="span">
          {I18n.t('ai_suggesting_score')}
        </Text>
      </>
    ) : (
      <>
        <AIBadge />
        <Text className="tw-text-tci-black" size="sm" tag="span" weight="semibold">
          {I18n.t(LABEL_KEYS[state], { score })}
        </Text>
        <Icon color="tci-purple" icon="InfoAlternate" size={18} />
      </>
    )}
  </span>
);

export default AISuggestionChip;
